import React from 'react';
import Label from 'ps-react/Label';

/** Required label */
export default function ExampleRequired() {
  return <Label htmlFor="test" label="test" required />
}
